import { InputTable, Tr } from '../styles';
import { Table, Button } from 'reactstrap';
import React, { useEffect } from 'react';

import {
  manageEditable,
  manageAmount,
  formatter
  // checkFormat,
  // maskOnlyNumbers
} from '../utils';
import { editarProdutos } from 'store/action/GasOrder/gasOrder';

export const ProductTable = ({
  data,
  setData,
  dispatch,
  selectedOpportunity
}) => {
  const columns = [
    'CÓDIGO',
    'NOME',
    // 'VALOR',
    // 'DESCONTO',
    'QUANTIDADE',
    'ENTRADA',
    'REMOVER',
    'EDITAR'
  ];

  const handleCancel = (index, item) => {
    manageEditable(index, data, setData);
    // document.getElementById(`${index}.value`).value = formatter(item.value);
    // document.getElementById(`${index}.discount`).value = `${item.discount}%`;
    document.getElementById(`${index}.amount`).value = item.amount;
    document.getElementById(`${index}.entrada`).value = item.entrada;
  };

  useEffect(() => {
    data.map((produto, index) => {
      if (
        produto.amount !== document.getElementById(`${index}.amount`).value ||
        produto.entrada !== document.getElementById(`${index}.entrada`).value
      ) {
        document.getElementById(`${index}.amount`).value = produto.amount;
        document.getElementById(`${index}.entrada`).value = produto.entrada;
      }
    });
  }, [data]);

  const manageDispatch = (produtos) => {
    dispatch(
      editarProdutos({
        produtos: produtos,
        index: selectedOpportunity
      })
    );
  };

  return (
    <Table style={{ borderBottom: '1px solid #e9ecef' }}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                backgroundColor: '#f6f9fc'
              }}
              key={index}
            >
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          return (
            <Tr key={index}>
              <td>{item.code}</td>
              <td>{item.name}</td>
              {/* <td>
                <InputTable
                  defaultValue={formatter(item.value)}
                  onBlur={() => {
                    document.getElementById(`${index}.value`).value =
                      checkFormat(
                        document.getElementById(`${index}.value`).value
                      );
                  }}
                  disabled={!item.editable}
                  editable={item.editable}
                  id={`${index}.value`}
                  onChange={(event) => {
                    if (
                      event.target.value === '' ||
                      isNaN(event.target.value)
                    ) {
                      event.target.value = '0';
                    } else {
                      let exibValue = maskOnlyNumbers(event.target.value);
                      document.getElementById(`${index}.value`).value =
                        exibValue.formatedValue;
                    }
                  }}
                ></InputTable>
              </td>
              <td>
                <InputTable
                  defaultValue={`${item.discount}%`}
                  disabled={!item.editable}
                  editable={item.editable}
                  onBlur={() => {
                    document.getElementById(
                      `${index}.discount`
                    ).value = `${document
                      .getElementById(`${index}.discount`)
                      .value.replace('%', '')}%`;
                  }}
                  id={`${index}.discount`}
                  onChange={(event) => {
                    let exibValue = maskOnlyNumbers(event.target.value);
                    document.getElementById(`${index}.discount`).value =
                      exibValue.exibValue;
                  }}
                ></InputTable>
              </td> */}
              <td>
                <InputTable
                  defaultValue={item.amount}
                  disabled={!item.editable}
                  editable={item.editable}
                  id={`${index}.amount`}
                  onChange={(event) => {
                    if (event.target.value === '0') {
                      document.getElementById(`${index}.amount`).value = '1';
                    }
                    document.getElementById(`${index}.amount`).value = document
                      .getElementById(`${index}.amount`)
                      .value.replace(/\D/g, '');
                  }}
                ></InputTable>
              </td>
              <td>
                <InputTable
                  defaultValue={item.entrada}
                  disabled={!item.editable}
                  editable={item.editable}
                  id={`${index}.entrada`}
                  onChange={(event) => {
                    document.getElementById(`${index}.entrada`).value = document
                      .getElementById(`${index}.entrada`)
                      .value.replace(/\D/g, '');
                  }}
                ></InputTable>
              </td>

              <td>
                <Button
                  size="sm"
                  color="danger"
                  onClick={() => {
                    let copyOfData = [...data];
                    copyOfData.splice(index, 1);
                    setData(copyOfData);
                    manageDispatch(copyOfData);
                  }}
                >
                  <li className="fas fa-trash"></li>
                </Button>
              </td>
              <td>
                {item.editable ? (
                  <>
                    {' '}
                    <Button
                      size="sm"
                      style={{
                        backgroundColor: '#2dce89',
                        color: '#fff'
                      }}
                      onClick={() => {
                        let amount = parseFloat(
                          document
                            .getElementById(`${index}.amount`)
                            .value.replace(',', '.'),
                          10
                        );

                        let entrada = parseFloat(
                          document
                            .getElementById(`${index}.entrada`)
                            .value.replace(',', '.'),
                          10
                        );

                        manageAmount(
                          amount,
                          data,
                          setData,
                          index,
                          manageDispatch,
                          entrada
                        );

                        manageEditable(index, data, setData);
                      }}
                    >
                      <li className="fas fa-check"></li>
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        handleCancel(index, item);
                      }}
                    >
                      <li className="fas fa-ban"></li>
                    </Button>
                  </>
                ) : (
                  <Button
                    size="sm"
                    color="info"
                    onClick={() => {
                      manageEditable(index, data, setData);
                    }}
                  >
                    <li className="fas fa-edit"></li>
                  </Button>
                )}
              </td>
            </Tr>
          );
        })}
      </tbody>
    </Table>
  );
};
